/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [
  {
    action: 'getCustomerPropertyBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_PROPERTY_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/property/:systemGameId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_PROPERTY,
    requestSchema: requestSchemas.customerProperties.getCustomerPropertyBySystemGameId,
  },
  {
    action: 'updateCustomerPropertyById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_PROPERTY_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/property/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_PROPERTY,
    requestSchema: requestSchemas.customerProperties.updateCustomerPropertyById,
  },
];
